import PauseIcon from '../svg/pause.svg?react';

export const StyledPauseIcon = PauseIcon;
